import { takeUntil } from 'rxjs/operators';
import { ActionAsideMenuOpenClose } from './../../../state-manager-actions/action-aside-menu/action-aside-menu';
import { Select, Store } from '@ngxs/store';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ENUM_ROLES } from '@module-role/enums/enum-roles';
import { CurrentUserService } from '@services/current-user/current-user.service';
import { ModelUser } from '@module-user/models/model-user';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { PrescriberModalService } from '@module-claims/services/prescriber-modal.service';
import { PharmacyModalService } from '@module-claims/services/pharmacy-modal.service';
import { AuditClaimSearchModalService } from '@module-claims/services/audit-claim-search-modal.service';
import {
  CUSTOMER_DETAILS_URL_AUDIT_340B,
  CUSTOMER_DETAILS_URL_DEFAULT,
  CUSTOMER_DETAILS_URL_HEALTH_SYSTEM,
  CUSTOMER_DETAILS_URL_PHARMACY_CHAIN,
  CUSTOMER_LIST_URL_AUDIT_340B,
  CUSTOMER_LIST_URL_DEFAULT,
  CUSTOMER_LIST_URL_HEALTH_SYSTEM,
  CUSTOMER_LIST_URL_PHARMACY_CHAIN
} from '@module-customer-management/constants/customer-route-constants';
import { isCEUser, isHealthSystemCustomerUser } from '@module-role/utils';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  animations: [
    trigger('menuInOut', [
      state('void', style({ opacity: 0 })),
      state('*', style({ opacity: 1 })),
      transition(':enter', animate('200ms ease-out')),
      transition(':leave', animate('1000ms ease-in'))
    ])
  ],
  standalone: false
})
export class SideMenuComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject();
  state = 'some';
  isMenuOpen = true;
  @Select('stateAsideMenu')
  isMenuOpenState!: Observable<ActionAsideMenuOpenClose>;
  public roleTypes = ENUM_ROLES;
  public currentUser$!: Observable<ModelUser>;
  public currentRoute = '';

  customerDetailsUrlDefault = CUSTOMER_DETAILS_URL_DEFAULT;
  customerDetailsUrlAudit340B = CUSTOMER_DETAILS_URL_AUDIT_340B;
  customerDetailsUrlHealthcareProvider = CUSTOMER_DETAILS_URL_HEALTH_SYSTEM;
  customerDetailsUrlPharmacyChain = CUSTOMER_DETAILS_URL_PHARMACY_CHAIN;

  customerListUrlDefault = CUSTOMER_LIST_URL_DEFAULT;
  customerListUrlAudit340B = CUSTOMER_LIST_URL_AUDIT_340B;
  customerListUrlHealthcareProvider = CUSTOMER_LIST_URL_HEALTH_SYSTEM;
  customerListUrlPharmacyChain = CUSTOMER_LIST_URL_PHARMACY_CHAIN;
  isCEUser = false;
  isHealthSystemUser = false;

  constructor(
    private _store: Store,
    private _currentUser: CurrentUserService,
    private _router: Router,
    private _prescriberModalService: PrescriberModalService,
    private _pharmacyModalService: PharmacyModalService,
    private _auditClaimSearchModalService: AuditClaimSearchModalService
  ) {
    this._router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationStart || event instanceof NavigationEnd) {
        this.currentRoute = event.url;
      }
    });
  }

  ngOnDestroy(): void {
    this._store.dispatch(new ActionAsideMenuOpenClose(false));
    this.destroy$.next(null);
  }

  ngOnInit(): void {
    this.currentUser$ = this._currentUser.currentUser$;
    this.currentUser$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      this.isCEUser = isCEUser(user);
      this.isHealthSystemUser = isHealthSystemCustomerUser(user);
    });

    this.isMenuOpenState
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => (this.isMenuOpen = state.isOpen));
  }

  expanded(routesList: string[]): boolean {
    return routesList.some((route) => this.currentRoute.indexOf(route) > -1);
  }

  openPrescriberDetails(): void {
    this._prescriberModalService.open();
  }

  openPharmacyDetails(): void {
    this._pharmacyModalService.open();
  }

  openAuditClaimSearch(): void {
    this._auditClaimSearchModalService.open();
  }
}
